import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import Heading from './edu/Heading';
import { FormInput, FormLabel, FormTextArea, FormCheckbox, BaseForm } from './form';
import { PrimaryButton } from './buttons';
import formatPathname from '../helpers/formatPathname';
import './QuestionEdit.css';

function QuestionCreate(props) {
  const { onSubmit, location, t, slugMaps } = props;
  
  return (
    <BaseForm onSubmit={onSubmit}>
      <Heading>{t('askList.addTitle')}</Heading>
      <FormInput
        labelRenderer={() => <FormLabel>{t('askList.prompt')}</FormLabel>}
        name="question"
      />
      <FormTextArea
        labelRenderer={() => (
          <FormLabel note={t('askList.optional')}>
            {t('askList.detailsPrompt')}
          </FormLabel>
        )}
        name="details"
      />
      <p className="question-edit__location-label">
        {t('askList.currentLocation')}
      </p>
      <p className="question-edit__location-path">
        {formatPathname(
          location.pathname,
          slugMaps.modules,
          slugMaps.introPages,
          slugMaps.lessons
        )}
      </p>
      <p>{t('askList.locationPrompt')}</p>
      <FormCheckbox name="includeLocation">
        {t('askList.includeLocation')}
      </FormCheckbox>

      <div className="question-edit__button-container">
        <PrimaryButton 
          colorScheme="blue" 
          label={t('askList.addQuestion')} 
          type="submit"
        />
      </div>
    </BaseForm>
  );
}

QuestionCreate.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  t: PropTypes.func.isRequired,
  slugMaps: PropTypes.shape({
    modules: PropTypes.object,
    introPages: PropTypes.object,
    lessons: PropTypes.object
  }).isRequired
};

export default translate()(QuestionCreate);



// WEBPACK FOOTER //
// ./src/components/QuestionCreate.js